export default __webpack_public_path__ + "static/media/sy-epc.e338f717.png";